<template>
  <div class="w-full flex flex-wrap gap-4 px-4 justify-start">
    <MainLoader :visible="true" size="80px" color="blue" v-if="searchStore.getListOfHotels.length === 0" />
    
    <template v-else>
      <div
        class="card-view-detailing bg-white border border-gray-200 rounded-lg shadow-sm mt-2 md:mt-0 hover:bg-gray-100"
        v-for="result in searchStore.getListOfHotels"
        :key="result.id"
      >
        <HotelCard :result="result" :key="result.id" class="shadow-2xl" />
      </div>
    </template>

    <p v-if="searchStore.getListOfHotels.length === 0" class="w-full text-center text-gray-600 flex items-center justify-center min-h-[50vh]">No properties found</p>
  </div>
</template>

<script setup>
import HotelCard from "./hotel-card.vue";
import MainLoader from "../../src/UI/mainLoader.vue";
import { useSearchStore } from "../../stores/search.module";

const searchStore = useSearchStore();
</script>

<style scoped>
.card-view-detailing {
  flex: 0 0 calc(33.333% - 1rem);
  max-width: calc(33.333% - 1rem);
}

/* Tablet: 2 cards per row */
@media (max-width: 1024px) {
  .card-view-detailing {
    flex: 0 0 calc(50% - 1rem);
    max-width: calc(50% - 1rem);
  }
}

/* Mobile: 1 card per row */
@media (max-width: 640px) {
  .card-view-detailing {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
